module.exports = __webpack_public_path__ + "img/user-add.76dc6de4.svg";